export const increment = (
  value: number,
  step: number,
): number => ((value + step) - (value % step));

export const decrement = (
  value: number,
  step: number,
): number => ((value % step) ? value - (value % step) : value - step);

/**
 * This coerces the value to a string, which prevents "01" from being displayed on direct entry
 */
export const format = (value?: number): string => (
  (value !== null && typeof value !== 'undefined')
    ? value.toString()
    : ''
);

export const parse = (value: string): number => Math.abs(Math.round(Number(value)));

/**
 * Coerce the number to be in the range of min/max
 */
export const normalize = (
  value: number,
  min: number,
  max: number,
): number => Math.max(Math.min(value, max), min);
